import actions from './actions'
import getters from "./getters";
import mutations from './mutations'

const AgendaCreation = {
  state: () => ({
    apiErrors: [],
    courses: [],
    creationStep: 1,
    disciplines: [],
    isUpdate: false,
    modules: [],
    scheduleConfig: {
      cor: null,
      cursos_ids: [],
      data_inicio: null,
      data_fim: null,
      dias_da_semana: [1, 2, 3, 4, 5],
      disciplinas_ids: [],
      id: null,
      materiais_estudo_agenda: [1, 2, 3, 4, 5, 6, 7],
      modulos_ids: [],
      tempo_diario_estudo: 0,
    },
    studyMaterials: [],
    totalContentTime: [],
  }),
  actions,
  getters,
  mutations,
}

export default AgendaCreation
